'use client';

import Image from 'next/image';

import { CustomLink } from '@/components/atom/CustomLink';
import { ROUTES } from '@/constants';
import { useAuthStore } from '@/stores/AuthStore';
import { useGlobalStore } from '@/stores/GlobalStore';

export const ClientSideBanner = ({
  className,
  communityPath,
}: {
  className: string;
  communityPath: string;
}) => {
  const isLogin = useAuthStore((state) => state.isLogin);
  const setIsShowLoginRedirectionConfirmModal = useGlobalStore(
    (state) => state.setIsShowLoginRedirectionConfirmModal,
  );

  const bannerImageUrl = `/assets/pngs/aside-section-banner-${isLogin ? 'private' : 'guest'}.png`;

  return (
    <CustomLink
      className={className}
      href={ROUTES.COMMUNITY_CATEGORY.pathname({
        category: communityPath,
      })}
      onClick={(e) => {
        if (isLogin) return;

        e.preventDefault();
        setIsShowLoginRedirectionConfirmModal(true);
      }}
    >
      <Image fill alt="정책" loading="lazy" src={bannerImageUrl} />
    </CustomLink>
  );
};

export const ClientSideQRCode = ({
  qrCodeUrl,
  width,
  height,
}: {
  qrCodeUrl: string;
  width: number;
  height: number;
}) => {
  const IMAGE_PLACEHOLDER = '/assets/pngs/placeholder.png';

  return (
    <Image
      alt="QR코드"
      height={height}
      loading="lazy"
      src={qrCodeUrl}
      width={width}
      onError={(e) => {
        e.currentTarget.src = IMAGE_PLACEHOLDER;
      }}
    />
  );
};
